import {
  LockOutlined,
  LoginOutlined,
  UserOutlined,
} from "@ant-design/icons";
import {
  LoginForm,
  ProFormCheckbox,
  ProFormItem,
  ProFormText,
} from "@ant-design/pro-components";
import styles from './Login.module.css';
import * as actions from '../../../store/actions/action';
import { connect } from "react-redux";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Alert } from "antd";
import Logo from '../../../Components/Logo/Logo'
const Login = ({onSignIn , loading , token , error , ClearError}) => {
  const onLogin = (data)=>{
    onSignIn(data.username , data.password)
  }
  const navigate = useNavigate();
  useEffect(()=>{
    if (token) {
      navigate('/')
    }
  } , [token])
  return (
    <div className={styles.Login} style={{ backgroundColor: "white" }}>
      <LoginForm
        // logo="https://github.githubassets.com/images/modules/logos_page/Octocat.png"
        className={styles.LoginForm}
        title={<Logo width="180"/>}
        subTitle="ورود به پنل ادمین"
        onFinish={(data)=>{
          onLogin(data);
        }}
        submitter={{submitButtonProps : {loading , icon : <LoginOutlined />}}}
      >
          <>
            <ProFormText
              name="username"
              fieldProps={{
                size: "large",
                prefix: <UserOutlined className={"prefixIcon"} />,
              }}
              placeholder="نام کاربری"
              rules={[
                {
                  required: true,
                  message: "!نام کاربری را وارد نکرده‌اید",
                },
              ]}
            />
            <ProFormText.Password
              name="password"
              fieldProps={{
                size: "large",
                prefix: <LockOutlined className={"prefixIcon"} />,
              }}
              placeholder="رمز عبور"
              rules={[
                {
                  required: true,
                  message: "!رمز عبور را وارد نکرده‌اید",
                },
              ]}
            />
          </>
    
       
        <div
          style={{
            marginBlockEnd: 24,
          }}
        >
          <ProFormCheckbox noStyle name="autoLogin">
            مرا به خاطر بسپار
          </ProFormCheckbox>
          <a
            style={{
              float: "right",
            }}
          >
            رمز عبورم را فراموش کردم
          </a>
        
        </div>
      </LoginForm>
      {error ? <Alert showIcon onClose={ClearError} closable type="error" message="نام کاربری یا رمز عبور اشتباه است." /> : null}
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    token: state.token,
    loading : state.loading,
    error : state.error
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setToken: (token) => dispatch(actions.TokenSetter(token)),
    onSignIn : (username , password) =>dispatch(actions.SignInStart(username,password)),
    ClearError : ()=>dispatch(actions.ClearError())
  };
};
export default connect(mapStateToProps , mapDispatchToProps)(Login);